import * as Linking from 'expo-linking';
import { Platform } from 'react-native';

/** Canonical web origin for share links; also the app's universal-link host. */
const WEB_ORIGIN = 'https://removebeforeflight.app';

/**
 * Share URL for a template invite token. On native we build an https universal
 * link (`removebeforeflight.app` is registered as an app/associated domain),
 * which opens the app for installed users and the web for everyone else. On
 * web, `Linking.createURL` yields an origin-relative URL so dev and preview
 * deployments produce working links.
 */
export function templateShareUrl(token: string): string {
  const path = `join/template/${token}`;
  if (Platform.OS === 'web') return Linking.createURL(path);
  return `${WEB_ORIGIN}/${path}`;
}
